





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATEBLOGSECTION
// UPDATEBLOGSECTION


const UPDATEBLOGSECTION= createAsyncThunk(
  "updateBlogSection/updateBlogSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateBlogSectionSlice = createSlice({
  name: "updateBlogSectionSlice",
  initialState: {
    updateBlogSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateBlogSection: (state) => {
        state.updateBlogSection.loading = false
        state.updateBlogSection.error = false
        state.updateBlogSection.data = []
        state.updateBlogSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEBLOGSECTION.fulfilled, (state, action) => {
      state.updateBlogSection = {
        ...state.updateBlogSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEBLOGSECTION.pending, (state, action) => {
      state.updateBlogSection = {
        ...state.updateBlogSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEBLOGSECTION.rejected, (state, action) => {
      state.updateBlogSection = {
        ...state.updateBlogSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateBlogSectionAction = {
    UPDATEBLOGSECTION,
};

export { updateBlogSectionAction };
export default updateBlogSectionSlice.reducer;
export const {setInitialStateOfupdateBlogSection} = updateBlogSectionSlice.actions
